import Part from '../part/Part';
import capitalizeFirstLetter from '../../../../utils/capitalizeFirstLetter';
import { NavLink, useLocation} from 'react-router-dom';
import {useSessionContext} from '../../contexts/sectionContext';
import generateKey from '/src/utils/generateKey';
import './ListPart.css';

function ListPart({data, name, numberOfData = 0, plural = true, svgName, path, label}) {
    
    const { section , setSectionTroughtEventClick } = useSessionContext();

    const location = useLocation();
    
    label = label ? label : name;
    const labelPlural = plural ? label + 's' : label;
    const searchUrl = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
    const isSelected = searchUrl.includes(`${name}`) || searchUrl.includes(`${labelPlural}`);
    const isActive = section == name;

    const createLink = (link) => {
        return (
            <NavLink to={link.url} key={generateKey()}>
                <button className={ decodeURI(location.pathname) == link.url ? "current-page" : "child_btn"}>
                    <li><span>{capitalizeFirstLetter(link.name)}</span></li>
                </button>
            </NavLink>
        )
    }

    return (
        <Part isActive={isActive} isSelected={isSelected}>
            <div className={`container-part ${isSelected ? 'selected' : ''}`}>
                <div className="category index" onClick={setSectionTroughtEventClick}>
                    <div className='click-detector' data-name={name}></div>
                    <div className={'svg ' + (svgName != null ? svgName : name)}></div>
                    <span className="parent_txt">{capitalizeFirstLetter(labelPlural)} {numberOfData ? '(' + numberOfData + ')' : ''}</span>
                    <div className={`svg arrow ${isActive ? 'reverse' : ''}`}/>
                </div>
                <div className={`sidebar-list ${isActive ? 'active' : ''}`}>
                    {data && data.map(link => createLink(link))}
                </div>
            </div>
        </Part>
    )
}



export default ListPart